import React, {useState} from 'react';
import PageForm from "components/pageForm";
import {Outlet, useLocation} from "react-router-dom";
import SubNavbar from "components/SubNavbar/SubNavbar";
import SearchBar from "components/search/SearchBar";
import {TabF, TabsF} from "components/tabs/tabfile";
import PerimeterFilterButton from "components/perimeterFilter/PerimeterFilterButton";
import usePerimeterListFilter from "components/perimeterFilter/usePerimeterListFilter";

const TimeSheet = () => {
    const [searchValue, setSearchValue] = useState('');
    const [searchType, setSearchType] = useState('all');
    const perimeterFilter = usePerimeterListFilter();
    const location = useLocation();
    const pathname = location.pathname;

    const timeSheetSearchTypes = [
        { value: 'all', label: 'Tout', placeholder: 'Rechercher...' },
        { value: 'interimaire', label: 'Intérimaire', placeholder: 'Rechercher un intérimaire...' },
        { value: 'mission', label: 'Mission', placeholder: 'Rechercher une mission (intitulé ou numéro)...' },
        { value: 'releve', label: 'N° de relevé', placeholder: 'Rechercher un numéro de relevé...' }
    ];

    return (
        <>
            <PageForm>
                <SubNavbar>
                    <div className="w-full flex items-stretch h-full">
                        <div className="w-full flex flex-col tab:flex-row tab:justify-between gap-3">
                            <div className="flex items-center h-full">
                                <TabsF>
                                    <TabF label={"toBeChecked"} tabName={'À vérifier'}/>
                                    <TabF label={"litigation"} tabName={'Litige'}/>
                                    <TabF label={"checked"} tabName={'Vérifié'}/>
                                </TabsF>
                            </div>
                            <div className="flex flex-col tab:flex-row items-stretch tab:items-center gap-3 flex-shrink-0 tab:ml-4">
                                {perimeterFilter.isFilterShown && (
                                    <PerimeterFilterButton
                                        options={perimeterFilter.options}
                                        selectedIds={perimeterFilter.selectedIds}
                                        onChange={perimeterFilter.setSelectedIds}
                                    />
                                )}
                                <SearchBar
                                    searchValue={searchValue}
                                    onSearchChange={setSearchValue}
                                    searchType={searchType}
                                    onSearchTypeChange={setSearchType}
                                    placeholder="Rechercher..."
                                    customSearchTypes={timeSheetSearchTypes}
                                />
                            </div>
                        </div>
                    </div>
                </SubNavbar>
                {/* collé à la SubNavbar (comme demandé) */}
                <div className="col-span-12">
                    <Outlet
                        context={{
                            searchValue,
                            searchType,
                            perimeterIds: perimeterFilter.perimeterIds,
                            isPerimeterColumnShown: perimeterFilter.isColumnShown,
                            onPerimeterFilterRefused: perimeterFilter.handlePerimeterFilterRefusal,
                        }}
                    />
                </div>
            </PageForm>
        </>
    );
};

export default TimeSheet;